"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useCustomerProductList = void 0;
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = require("react");
var _useCustomerProductLists = require("./useCustomerProductLists");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; } /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * Copyright (c) 2022, salesforce.com, inc.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * All rights reserved.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * SPDX-License-Identifier: BSD-3-Clause
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          */
/**
 * This hook is built on top of the useCustomerProductLists hook,
 * to provide functionalities to manage a single list.
 * A typical use case is wish list.
 */
const useCustomerProductList = (name, type) => {
  // cpl is the shorthand for "Cutomer Product Lists"
  const cpl = (0, _useCustomerProductLists.useCustomerProductLists)();
  // @ts-ignore
  const self = (0, _react.useMemo)(() => {
    return _objectSpread(_objectSpread({}, cpl), {}, {
      get data() {
        return cpl.findListByName(name);
      },
      get items() {
        var _self$data;
        // @ts-ignore
        return ((_self$data = self.data) === null || _self$data === void 0 ? void 0 : _self$data.customerProductListItems) || [];
      },
      get isEmpty() {
        var _self$items;
        return !((_self$items = self.items) !== null && _self$items !== void 0 && _self$items.length);
      },
      get isInitialized() {
        var _self$data2;
        // @ts-ignore
        return !!((_self$data2 = self.data) !== null && _self$data2 !== void 0 && _self$data2.id);
      },
      // boolean value indicate the list
      // is populated with product details
      get hasDetail() {
        var _self$data3;
        // @ts-ignore
        return !!((_self$data3 = self.data) !== null && _self$data3 !== void 0 && _self$data3.hasDetail);
      },
      /**
       * Initialize the list.
       */
      init(options) {
        return cpl.getOrCreateList(name, type, options);
      },
      /**
       * Adds an item to the customer's list.
       * @param {Object} item item to be added to the list.
       * @param {string} item.id
       * @param {number} item.quantity
       */
      createListItem: function () {
        var _ref = (0, _asyncToGenerator2.default)(function* (item) {
          if (!self.isInitialized) {
            // @ts-ignore
            const list = yield self.init();
            return cpl.createListItem(list.id, item);
          }
          // @ts-ignore
          return cpl.createListItem(self.data.id, item);
        });
        return function createListItem(_x) {
          return _ref.apply(this, arguments);
        };
      }(),
      /**
       * Update an item to the customer's list.
       * @param {Object} item item to be updated
       * @param {string} item.id
       * @param {number} item.quantity
       */
      updateListItem: item => {
        // @ts-ignore
        return cpl.updateListItem(self.data.id, item);
      },
      /**
       * Remove an item from a customer product list
       *
       * @param {string} itemId the id of the item in the product list
       */
      removeListItem: itemId => {
        // @ts-ignore
        return cpl.removeListItem(self.data.id, itemId);
      },
      /**
       * Remove an item from the customer's list.
       *
       * @param {string} productId the id of the product
       */
      removeListItemByProductId: productId => {
        // @ts-ignore
        return cpl.removeListItemByProductId(self.data.id, productId);
      },
      /**
       * Find the item from list.
       * @param {string} productId
       * @returns {object} product list item
       */
      findItemByProductId(productId) {
        if (!self.isInitialized) {
          return undefined;
        }
        // @ts-ignore
        return cpl.findItemByProductId(self.data.id, productId);
      }
    });
  }, [cpl]);
  return self;
};
exports.useCustomerProductList = useCustomerProductList;